import { render, staticRenderFns } from "./xyjgdjForm.vue?vue&type=template&id=5bb21724&scoped=true&"
import script from "./xyjgdjForm.vue?vue&type=script&lang=js&"
export * from "./xyjgdjForm.vue?vue&type=script&lang=js&"
import style0 from "./xyjgdjForm.vue?vue&type=style&index=0&id=5bb21724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb21724",
  null
  
)

export default component.exports